import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../facility/internalRequestReceiveApproval/ContextAPI';
import Index from '../facility/internalRequestReceiveApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function InternalRequestFacilityReceiveApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-receive-approval'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
